import { clearLoginData, cookiesList, getCookie, setCookie } from '../../utils/cookies'
import { userSignOut } from '../../api/public'
import router from '../../router/index'
const user = {
    state: {
        userType: '',
        token: '',
        userId: '',
        account: ''
    },
    mutations: {
        setUserType: (state, type) => {
            state.userType = type
        },
        setToken: (state, token) => {
            state.token = token
        },
        setUserId: (state, userId) => {
            state.userId = userId
        },
        setAccount: (state, account) => {
            state.account = account
        },
        resetUserState: (state) => {
            state.userId = ''
            state.token = ''
            state.userType = ''
            state.account = ''
        }
    },
    actions: {
        getLocalInfo({commit, dispatch}) {
            let token = getCookie(cookiesList.token)
            let userId = getCookie(cookiesList.user_id)
            let userType = getCookie(cookiesList.user_type)
            let account = getCookie(cookiesList.account) 

            commit('setUserId', userId || '')
            commit('setToken', token || '')
            commit('setAccount', account || '')
            commit('setUserType', userType || '')

            // 获取服务费
            dispatch('setGlobalServiceCharge')
        },
        setLoginInfo ({commit, dispatch}, data) {
            // console.log(data)
            commit('setUserId', data.userId || '')
            commit('setToken', data.token || '')
            commit('setAccount', data.account || '')
            let userType = ""
            if (data.type == '1') userType = 'supplier'
            if (data.type == '2') userType = 'dealer'
            commit('setUserType', userType)  // 2020-12-08 增加  需求变化，一个手机号只允许一个身份
            
            setCookie(cookiesList.token, data.token || '') 
            setCookie(cookiesList.user_id, data.userId || '')
            setCookie(cookiesList.account, data.account || '')
            setCookie(cookiesList.user_type, userType || '')

            // 获取服务费
            dispatch('setGlobalServiceCharge')
        },
        clearLocalData({commit}) {
            commit('resetUserState')
            clearLoginData()
        },
        logOut({commit, dispatch, state}, type) {  // type - 1 主动退出登录  type - 2 被动退出登录（token失效，错误等） 
            if (type == 1) {
                userSignOut({
                    userId: state.userId,
                    token: state.token
                }).then(res => {
                    console.log(res)
                }).catch(err => {
                    console.log(err)
                })
            }
            dispatch('clearLocalData')
            router.push('/login?redirect=' + this.$route.fullPath)
        }
    },
    modules: {

    }
}

export default user